import { render, staticRenderFns } from "./copyright-icp.vue?vue&type=template&id=4fe322a6"
import script from "./copyright-icp.vue?vue&type=script&setup=true&lang=js"
export * from "./copyright-icp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./copyright-icp.vue?vue&type=style&index=0&id=4fe322a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports